import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    templateUrl: '500.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class P500Component {

  constructor() { }

}
